import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FileUpload } from 'src/app/model/file';
import { ModuleService } from 'src/app/services/modules/module.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Lock } from "../../../model/lock";
import { ItemCourseProgress, Level } from 'src/app/interfaces/academic-years';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from 'src/app/services/common/storage';
import { UserService } from 'src/app/services/user/user.service';
import { FirebaseApp } from '@angular/fire/app';
import { getAuth, signOut } from '@angular/fire/auth';
import { Store } from '@ngrx/store';
import { LogOut } from 'src/app/store/actions/auth.actions';
import { AppState } from 'src/app/store/app.states';
import { DocumentData } from '@angular/fire/firestore';
import { NavigationStateService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
  public year: String = "2025";
  public lastControles: { doc: DocumentData, receivedDoc: number, level: String }[] = [];
  public spinner: boolean = true;
  public items: ItemCourseProgress[] = [
    {
      iconClass: "bx bx-chalkboard", title: "Revue Biblique",
      description: "Dans ce module il est question de revoirs les bases doctrinales de la foi chrétienne.", level: "1",
      courses: "11", picture: "assets/img/courses/level1.svg",
      progression: { shared: 0, total: 0, prog: 0 }
    },
    {
      progression: { shared: 0, total: 0, prog: 0 }, iconClass: "bx bx-bible", title: "Fondements de la foi", description: "Ce module porte sur l’étude de l’histoire du christianisme, l’histoire de l’Église et de la Bible ainsi que sur les principes d’interprétation des Écritures.", level: "2",
      courses: "13",
      picture: "assets/img/courses/level11.svg"
    },
    { progression: { shared: 0, total: 0, prog: 0 }, iconClass: "bx bx-walk", title: "Dimension Individuelle ", description: "Ce module vise la mise à disposition d’outils pour être un acteur de l’établissement du règne et du royaume de Dieu dans toutes les sphères de la société. Comment être le sel de la Terre et la lumière du monde", level: "3", courses: "9", picture: "assets/img/courses/level22.svg" },
    { progression: { shared: 0, total: 0, prog: 0 }, iconClass: "bx bx-world", title: "Dimensions collective", description: "Dans ce module, il est question de comprendre quel est le regard de Dieu et le rôle de l’Église dans le monde aujourd’hui", level: "4", courses: "5", picture: "assets/img/courses/level2.svg" }];

  olympics$: any;

  constructor(public stateService:NavigationStateService,public storage: StorageService, public afApp: FirebaseApp, public router: Router, private localStorage: StorageService, public module: ModuleService,
    public userService: UserService, private store: Store<AppState>) {

  }


  private checkUser() {
    this.localStorage.getItem("user").then((x: string) => {
      const user = JSON.parse(x);
      if (!user) {
        this.storage.remove("isLevel2");
        const auth = getAuth(this.afApp);
        signOut(auth);
        this.store.dispatch(new LogOut(this.localStorage));
      }
      console.log(user)
    })
  }

  async ngOnInit(): Promise<void> {
    console.log("chargement composant CategoriesComponent");

    this.year = localStorage.getItem('year') ? localStorage.getItem('year') : this.year;

    this.loadData();


  }

  public async loadData() {
    this.lastControles = await this.module.getLastControle(this.year);
    if (this.lastControles.length == 0) {
      this.lastControles = [];
      this.lastControles.push({ doc: null, receivedDoc: null, level: "1" });
      this.lastControles.push({ doc: null, receivedDoc: null, level: "2" });
      this.lastControles.push({ doc: null, receivedDoc: null, level: "3" });
      this.lastControles.push({ doc: null, receivedDoc: null, level: "4" });
    }
    this.spinner = false;
    this.checkUser();
    this.progress(this.year);
  }

  private async progress(year: String) {
    for (let item of this.items) {
      this.module.progressValueOfLevel(year, "level" + item.level).
        subscribe((coursesLevel: Level[]) => {
          let lessonsShared = this.unlockedTotalCourses(coursesLevel);
          item.progression = { shared: lessonsShared, total: coursesLevel.length, prog: Math.round((lessonsShared * 100) / coursesLevel.length) };
          if (item.progression.prog == 100) {
            item.progression.shared = item.progression.total;
          }
          console.log(item.progression.total);
        })

    }
  }

  public updateDashboard() {
    this.lastControles = [];
    localStorage.setItem('year', this.year.toString())
    this.ngOnInit();
  }

  private unlockedTotalCourses(coursesLevel: Level[]): number {
    return coursesLevel.reduce((acc, level: Level) => {
      if (level.unlocked) {
        return acc + 1;
      }
      return acc;
    }, 0)
  }

  /**
   * 
   * @param level  Course level
   */
  public goToLessonsPage(level): void {
    this.router.navigate([`/student/lessons`], { state: { level: level, year: this.year } });

  }
  /**
   * 
   * @param level 
   * @param title 
   * @param islocked 
   */
  public courses(item) {
    this.stateService.setState("courses",item);
    console.log(item)
    this.router.navigate(["/detail-module"], { state: { title: item.title, level: item.level, year: this.year } });

  }

}
